const projects = {
  addSubproject: 'Ajouter un sous-projet',
  allProjects: 'Tous les projets',
  archivedProjects: 'Projets archivés',
  archiveExclusiveRelated: 'Archiver aussi les tâches et les objectifs qui appartiennent uniquement à ce projet',
  archiveExclusiveRelatedHelp: 'Les tâches et les objectifs également liés à un autre projet restent inchangés.',
  archiveProject: 'Archiver le projet',
  archiveProjectTitle: 'Archiver ce projet ?',
  cancelledProjects: 'Projets annulés',
  completeProjects: 'Projets complétés',
  createAProject: 'Créer un projet',
  noParentProject: 'Aucun',
  noProjectsToDisplay: 'Aucun projet à afficher',
  ongoingProjects: 'Projets en cours',
  parentProject: 'Projet parent',
  project: 'Projet',
  projectCreated: 'Projet créé',
  projectDeleted: 'Projet supprimé',
  projectHistoryAssigneeCleared: 'Responsable retiré',
  projectHistoryAssigneeSet: 'Responsable défini sur {{assignee}}',
  projectHistoryDeadlineCleared: 'Échéance supprimée',
  projectHistoryDeadlineSet: 'Échéance définie au {{date}}',
  projectHistoryParentCleared: 'Projet parent retiré',
  projectHistoryParentSet: 'Projet parent défini sur {{project}}',
  projectHistoryStartDateCleared: 'Date de début supprimée',
  projectHistoryStartDateSet: 'Date de début définie au {{date}}',
  projects: 'Projets',
  projectsDueForThisWeek: 'Projets dûs pour cette semaine',
  projectsDueForToday: 'Projets dûs pour aujourd\'hui',
  projectUpdated: 'Projet mis à jour',
  projectUpdatedFields: 'Mise à jour : {{fields}}',
  xSelectedProjects_one: '{{count}} projet sélectionné',
  xSelectedProjects_other: '{{count}} projets sélectionnés',
  youHaveNoOverdueProjects: 'Vous n\'avez aucun projet en retard.',
  youHaveXOverdueProjects_one: 'Vous avez {{count}} projet en retard.',
  youHaveXOverdueProjects_other: 'Vous avez {{count}} projets en retard.',
};

export default projects;
